import { render, staticRenderFns } from "./RentBorrowing.vue?vue&type=template&id=387c72f8&scoped=true"
import script from "./RentBorrowing.vue?vue&type=script&lang=js"
export * from "./RentBorrowing.vue?vue&type=script&lang=js"
import style0 from "./RentBorrowing.vue?vue&type=style&index=0&id=387c72f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387c72f8",
  null
  
)

export default component.exports